import { render } from "./ModalNewUser.vue?vue&type=template&id=07df5c40"
import script from "./ModalNewUser.vue?vue&type=script&lang=js"
export * from "./ModalNewUser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__